export default ({ className }:{ className?:string }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
        <path d="M6.00781 12.6667V27.3333H6.67448H26.0078V13L15.3411 4L6.00781 12.6667Z" fill="white"/>
        <path d="M10.7969 22.0898C10.7969 21.5376 11.2446 21.0898 11.7969 21.0898H14.1605C14.7128 21.0898 15.1605 21.5376 15.1605 22.0898V27.6353H10.7969V22.0898Z" fill="#437ADB"/>
        <path d="M5.82812 13.0898V27.6176H26.1918V13.0905" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M2.67188 14.6667L15.4573 4L29.3385 14.6667" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <rect x="18.9141" y="14.668" width="3.63636" height="3.63636" rx="1" fill="#437ADB"/>
    </svg>
)
